import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { EMPTY as empty } from 'rxjs';

@Component({
  selector: 'app-sub-item-content',
  templateUrl: './sub-item-content.component.html',
  styleUrls: ['./sub-item-content.component.css']
})
export class SubItemContentComponent implements OnInit {

  cont_model = {'table_name':'sub_item_content', 'sub_item_content_id':'0', 'sub_item_id':'', 'content_id':'', 
    'sub_item_no':'', 'unit_id':'', 'main_item_name':'', 'quantity':0, 'cost':0, 'total_cost':0, 'price':0, 
    'total_price':0, 'price_flex':0};

  constructor(private utils: Utils,	private applicationConstants: ApplicationConstants,	
    private queryList: QueryList, public dialog: MatDialog, 
    private dialogRef: MatDialogRef<SubItemContentComponent>, 
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    if(this.dialog_data['table_name'] != undefined)
      this.cont_model = this.dialog_data;
  }

  searchSubItem() {
    if (this.cont_model['sub_item_no'] != '') {
      let query = "SELECT `main_item`.`main_item_name`, `sub_item`.`sub_item_id`, `sub_item`.`cost`, `sub_item`.`price`, `sub_item`.`price_flex` " + 
        "FROM `main_item`, `sub_item` WHERE `sub_item`.`status` = '1' AND `sub_item`.`sub_item_no` = '" + 
        this.cont_model['sub_item_no'] + "' AND `sub_item`.`main_item_id` = `main_item`.`main_item_id`";
      let obj = {cmd: 'getList', query:query};
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.data['list'].length > 0) {
            this.cont_model['content_id'] = data.data['list'][0].sub_item_id; 
            this.cont_model['main_item_name'] = data.data['list'][0].main_item_name; 
            this.cont_model['quantity'] = 0;
            this.cont_model['cost'] = data.data['list'][0].cost;
            this.cont_model['total_cost'] = 0;
            this.cont_model['price'] = data.data['list'][0].price; 
            this.cont_model['total_price'] = 0;   
            this.cont_model['price_flex'] = data.data['list'][0].price_flex; 
          } 
          else  
            alert (" الرجاء التأكد من رقم الصنف ");
        });
    }
    else if (this.cont_model['sub_item_no'] == '')
      alert (" الرجاء إدخال رقم الصنف ");
  }

  calculate() {
    if (this.cont_model['quantity'] != 0) {
      this.cont_model['total_cost'] = 0;
      if (this.cont_model['cost'] != 0)
        this.cont_model['total_cost'] = Number((this.cont_model['quantity'] * this.cont_model['cost']).toFixed(2));
      this.cont_model['total_price'] = 0;
      if (this.cont_model['price'] != 0)
        this.cont_model['total_price'] = Number((this.cont_model['quantity'] * this.cont_model['price']).toFixed(2));
    }
    //else if (this.cont_model['quantity'] == 0)
      //alert (" الرجاء إدخال الكمية ");
  }

  calcTotalPrice() {
    this.cont_model['total_price'] = 0;
    if (this.cont_model['price'] != 0) {
      if (this.cont_model['quantity'] != 0)
        this.cont_model['total_price'] = (this.cont_model['quantity'] * this.cont_model['price']);
      //else if (this.cont_model['quantity'] == 0)
        //alert (" الرجاء إدخال الكمية ");
    }
    //else if (this.cont_model['price'] == 0)
      //alert (" الرجاء إدخال سعر الوحدة ");
  }

  add() {
    if (this.cont_model['sub_item_no'] != '' && this.cont_model['quantity'] != 0) {
      this.dialogRef.close(this.cont_model);
    }
    else if (this.cont_model['sub_item_no'] == '')
      alert (" الرجاء إدخال رقم الصنف ");
    else if (this.cont_model['quantity'] == 0)
      alert (" الرجاء إدخال الكمية ");
  }

  cancel() {
    this.dialogRef.close();
  }

}
